import { render, staticRenderFns } from "./TraxAccountRoleCrudForm.vue?vue&type=template&id=22518761"
import script from "./TraxAccountRoleCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxAccountRoleCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports